import { isCreateableField } from '@shared/data/entity/Entity';
import { EditableFieldRecord } from '@shared/scenes/entity/types';

export function toFieldJson(
  fields: EditableFieldRecord,
  workflowTemplate?: MBAPI.WorkflowTemplate,
): MBAPI.Scalar.JSONObject {
  return Object.entries(fields).reduce((memo, [componentId, field]) => {
    if (!isCreateableField(componentId, workflowTemplate)) {
      return memo;
    }
    return {
      ...memo,
      [componentId]: field?.toFieldJson() ?? null,
    };
  }, {});
}
